<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>

                <!-- header info -->
                <v-row class="pa-4"><h3>New complaint</h3></v-row>
                <v-row><v-divider></v-divider></v-row>
                <v-row class="pl-4 mt-6">
                    <owner_header :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="pl-4">
                    <caretaker_header :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="mt-6 mb-6"><v-divider></v-divider></v-row>
                
                <selections :reportedby="reportedby" :hokl_gebr="hokl_gebr" :hokl_klct_sel="hokl_klct_sel" :hokl_kloz_sel="hokl_kloz_sel"
                            :customerLiable="customerLiable" @updateData="updateData"/>

                <v-card fluid flat class="mt-3">
                    <hokl_hosm_components title="Complaint components" :components="components" @updateData="updateData"/>
                </v-card>

                <v-row dense>
                    <v-col cols="12" class="pr-6">
                        <v-form v-model="text_valid">
                            <v-textarea v-model="hokl_text" rows="3" required label="Incident description" v-bind:rules="descriptionRules"> {{ hokl_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData"/>
                </v-card>

                <v-row>
                    <v-col cols="12" class="pr-6">
                        <v-textarea v-model="hokl_memo" rows="3" label="Internal memo">{{ hokl_memo }}</v-textarea>
                    </v-col>
                </v-row>

                <v-card-actions style="height: 60px;">
                    <div v-if="error_message !== ''" style="background-color: #fecaca; padding: 3px; width: 100%; display: flex; align-items: center; margin-right: 30px;">
                        <v-icon color="red" class="ml-3 mb-auto mt-1">mdi-close-circle</v-icon>
                        <div style="color:red; padding-left: 20px; padding-right: 20px;">{{ error_message }}</div>
                    </div>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!text_valid || !enable_action_buttons || !incident_slot" v-on:click="addHokl()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>

    </v-dialog>
</template>
  
<script>

import owner_header from '@/components/huov/hokl/owner_header.vue'
import caretaker_header from '@/components/huov/hokl/caretaker_header.vue'
import hokl_hosm_components from '@/components/huov/ui/hokl_hosm_components.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';
import selections from '@/components/huov/hokl/ui/screen_selections.vue';

export default {
    props: {
        huov_encrid: String
    },
    components: {
        owner_header,
        caretaker_header,
        hokl_hosm_components,
        hokl_hosm_links,
        selections
    },

    data() {
        return {
            dialog: false,
            text_valid: false,
            hokl_memo: '',
            hokl_text: '',
            hokl_klct_sel: [],
            hokl_kloz_sel: [],
            hokl_gebr: '',
            reportedby: '',
            incident_slot: '',
            customerLiable: false,
            components:[{key: 0, description: '', amount: ''}], // start with 1 empty record
            links:[],
            enable_action_buttons: true,
            descriptionRules: [v => !!v || "A description / value is required"],
            error_message: '',
        }
    },
    methods: {
        open() {
            this.hokl_memo = '';
            this.hokl_text = '';
            this.reportedby = '';        
            this.customerLiable = false;
            this.hokl_gebr = '';
            this.incident_slot = '';
            this.hokl_klct_sel = [];
            this.hokl_kloz_sel = [];
            this.links = [];
            this.components = [{key: 0, description: '', amount: ''}];
            this.enable_action_buttons = true,
            this.dialog = true;
            this.error_message = '';
        },
        updateData(data){
            this[data.field] = data.value;
        },
        addHokl() {
            this.$axios
                .post("ares/json/ares/huov/hokl/addHokl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHokl"
                    },
                    addHokl: {
                        huov_encrid: this.huov_encrid,
                        hokl_text: this.hokl_text,
                        hokl_memo: this.hokl_memo,
                        hokl_gebr: this.hokl_gebr,
                        selected_klct: this.hokl_klct_sel,
                        selected_kloz: this.hokl_kloz_sel,
                        reportedby: this.reportedby,
                        incident_slot: this.incident_slot,
                        customerLiable: this.customerLiable,
                        links: this.links,
                        components: this.components,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.error_message = res.data.error.message;
                        setTimeout(() => {
                            this.error_message = '';
                        }, 5000);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false;                        
                    }
                })
        }
    }
}
</script>
  
<style scoped>
	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>